export const mockData = {
  company: {
    name: "NotchUp Virtual Tours",
    tagline: "Let Customers Walk Through Your Business Before They Visit.",
    description: "High-resolution 360° Virtual Tours for Restaurants, Hotels, Real Estate, Schools, Resorts, and Commercial Spaces.",
    location: "Manipal & Udupi, Karnataka, India",
    email: "vistava360@gmail.com",
    phone: "+91 XXXXX XXXXX", // To be updated
    whatsapp: "+91 XXXXX XXXXX", // To be updated
  },

  stats: {
    businessesServed: 150,
    toursCreated: 320,
    citiesCovered: 15,
    satisfiedClients: 145,
  },

  benefits: [
    {
      icon: "Users",
      title: "Increase Customer Trust",
      description: "Let customers explore your space remotely before visiting, building confidence and trust in your business.",
    },
    {
      icon: "TrendingUp",
      title: "Improve Online Visibility",
      description: "Stand out in search results with interactive 360° tours that boost engagement and SEO rankings.",
    },
    {
      icon: "MousePointerClick",
      title: "Higher Engagement",
      description: "Interactive tours keep visitors on your website 5x longer than traditional photos.",
    },
    {
      icon: "Trophy",
      title: "Stand Out from Competitors",
      description: "Showcase your space with cutting-edge technology that sets you apart from the competition.",
    },
    {
      icon: "Clock",
      title: "24/7 Virtual Access",
      description: "Customers can explore your space anytime, anywhere, without geographical limitations.",
    },
    {
      icon: "Sparkles",
      title: "Premium Brand Image",
      description: "Demonstrate innovation and professionalism with immersive virtual tour technology.",
    },
  ],

  industries: [
    { icon: "Home", name: "Homes • Apartments • Villas" },
    { icon: "Building2", name: "Offices • Co-working Spaces" },
    { icon: "Utensils", name: "Restaurants • Cafés • Hotels • Resorts" },
    { icon: "ShoppingBag", name: "Retail Stores • Showrooms" },
    { icon: "GraduationCap", name: "Schools • Colleges • Campuses" },
    { icon: "Hospital", name: "Hospitals • Clinics • Pharmacies" },
    { icon: "Dumbbell", name: "Gyms • Salons • Spa • Studios" },
    { icon: "PartyPopper", name: "Event Halls • Banquets • Conventions" },
    { icon: "Warehouse", name: "Warehouses • Industrial Spaces" },
    { icon: "Church", name: "Temples • Heritage Sites" },
    { icon: "Gamepad2", name: "Gaming Zones • Indoor Sports" },
  ],

  process: [
    {
      step: 1,
      title: "Site Visit",
      description: "Our team visits your location to understand your space and requirements.",
      icon: "MapPin",
    },
    {
      step: 2,
      title: "Professional 360° Capture",
      description: "We use advanced 360° cameras to capture high-resolution panoramic images.",
      icon: "Camera",
    },
    {
      step: 3,
      title: "Editing & Optimization",
      description: "Professional editing ensures seamless transitions and perfect image quality.",
      icon: "Wand2",
    },
    {
      step: 4,
      title: "Interactive Virtual Tour",
      description: "We create an interactive experience with hotspots, navigation, and branding.",
      icon: "MonitorPlay",
    },
    {
      step: 5,
      title: "Delivery & Website Integration",
      description: "Receive your tour with easy embedding options for your website and social media.",
      icon: "Rocket",
    },
  ],

  gallery: [
    {
      id: 1,
      title: "Luxury Hotel Lobby",
      category: "Hotels & Resorts",
      thumbnail: "https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?w=800",
      tourUrl: "#demo-tour", // Placeholder
    },
    {
      id: 2,
      title: "Modern Restaurant Interior",
      category: "Restaurants & Cafés",
      thumbnail: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800",
      tourUrl: "#demo-tour",
    },
    {
      id: 3,
      title: "Premium Residential Property",
      category: "Real Estate",
      thumbnail: "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=800",
      tourUrl: "#demo-tour",
    },
    {
      id: 4,
      title: "Corporate Office Space",
      category: "Commercial",
      thumbnail: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
      tourUrl: "#demo-tour",
    },
    {
      id: 5,
      title: "Educational Campus",
      category: "Education",
      thumbnail: "https://images.unsplash.com/photo-1562774053-701939374585?w=800",
      tourUrl: "#demo-tour",
    },
    {
      id: 6,
      title: "Retail Showroom",
      category: "Retail",
      thumbnail: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800",
      tourUrl: "#demo-tour",
    },
  ],

  testimonials: [
    {
      id: 1,
      name: "Rajesh Kumar",
      business: "The Grand Orchid Hotel, Manipal",
      rating: 5,
      text: "The virtual tour has transformed how guests discover our hotel. Bookings increased by 40% after adding the tour to our website. Highly professional service!",
      avatar: "RK",
    },
    {
      id: 2,
      name: "Priya Shetty",
      business: "Coastal Cuisine Restaurant, Udupi",
      rating: 5,
      text: "Customers love exploring our restaurant virtually before visiting. The 360° tour showcases our ambiance perfectly. Worth every rupee!",
      avatar: "PS",
    },
    {
      id: 3,
      name: "Arun Prabhu",
      business: "Elite Realty Solutions",
      rating: 5,
      text: "Game-changer for our real estate business. Clients can view properties remotely, saving time for everyone. The quality is outstanding!",
      avatar: "AP",
    },
    {
      id: 4,
      name: "Meera Nayak",
      business: "Wellness Spa & Salon, Manipal",
      rating: 5,
      text: "The virtual tour helped us attract premium clients who appreciate our facility before booking. Professional, timely, and excellent results!",
      avatar: "MN",
    },
  ],

  faqs: [
    {
      question: "What is a 360° Virtual Tour?",
      answer: "A 360° Virtual Tour is an interactive, immersive experience that allows viewers to explore a physical space remotely. Using high-resolution panoramic images, viewers can navigate through rooms, look in all directions, and get a realistic sense of the space as if they were physically there.",
    },
    {
      question: "How long does it take to create a virtual tour?",
      answer: "Typically, the entire process takes 5-7 business days from the site visit to final delivery. This includes photography, editing, optimization, and creating the interactive tour. Rush services are available for urgent requirements.",
    },
    {
      question: "Can I embed the tour on my website?",
      answer: "Absolutely! We provide easy-to-use embed codes that work with all major website platforms including WordPress, Wix, Shopify, and custom websites. We also provide links for social media sharing.",
    },
    {
      question: "What equipment do you use?",
      answer: "We use professional-grade 360° cameras that capture high-resolution images (up to 8K quality). This ensures crystal-clear visuals and smooth navigation for the best user experience.",
    },
    {
      question: "Do you serve locations outside Manipal and Udupi?",
      answer: "Yes! While we're based in Manipal and Udupi, we serve clients across Karnataka and neighboring states. Contact us to discuss your location and requirements.",
    },
    {
      question: "How much does a virtual tour cost?",
      answer: "Pricing depends on the size of your space, number of locations, and additional features required. Contact us for a customized quote based on your specific needs. We offer competitive packages for all business sizes.",
    },
  ],

  socialLinks: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    youtube: "#",
  },
};
